import axios from 'axios';
import '../helpers/api_helper';
import { api } from '../config';

const BASE = api.API_URL;

// Objetivos
export const getIvghObjetivos = (ejercicio) =>
  axios.get(`${BASE}/ivgh/config/objetivos`, { params: ejercicio ? { ejercicio } : {} });

export const saveIvghObjetivo = (data) =>
  axios.post(`${BASE}/ivgh/config/objetivos`, data);

export const deleteIvghObjetivo = (id) =>
  axios.delete(`${BASE}/ivgh/config/objetivos/${id}`);

// Categorías
export const getIvghCategorias = () =>
  axios.get(`${BASE}/ivgh/config/categorias`);

export const saveIvghCategoria = (data) =>
  axios.post(`${BASE}/ivgh/config/categorias`, data);

// Empleados
export const getIvghEmpleados = () =>
  axios.get(`${BASE}/ivgh/config/empleados`);

export const saveIvghEmpleado = (data) =>
  axios.post(`${BASE}/ivgh/config/empleados`, data);

export const deleteIvghEmpleado = (id) =>
  axios.delete(`${BASE}/ivgh/config/empleados/${id}`);

export const toggleIvghEmpleado = (id) =>
  axios.patch(`${BASE}/ivgh/config/empleados/${id}/toggle`);

// Equipos
export const getIvghEquipos = (ejercicio) =>
  axios.get(`${BASE}/ivgh/config/equipos`, { params: ejercicio ? { ejercicio } : {} });

export const saveIvghEquipo = (data) =>
  axios.post(`${BASE}/ivgh/config/equipos`, data);

export const deleteIvghEquipo = (id) =>
  axios.delete(`${BASE}/ivgh/config/equipos/${id}`);

// Usuarios ERP (para selectores)
export const getUsuariosErp = () =>
  axios.get(`${BASE}/ivgh/config/usuarios-erp`);

// Empleados Kronaly (por empresa)
export const getEmpleadosKronaly = (empresaId) =>
  axios.get(`${BASE}/ivgh/config/kronaly-empleados`, { params: { empresa_id: empresaId } });

// Vincular empleado Kronaly ↔ ERP
export const vincularEmpleado = (data) =>
  axios.post(`${BASE}/ivgh/config/vincular-empleado`, data);

// Dashboard IVGH
export const getIvghDashboard = (ejercicio, empresaId, mes) =>
  axios.get(`${BASE}/ivgh/dashboard`, { params: { ejercicio, empresa_id: empresaId || 'all', ...(mes != null ? { mes } : {}) } });

// Vista por proyecto
export const getIvghProyectos = (ejercicio, empresaId, page = 1, limit = 50) =>
  axios.get(`${BASE}/ivgh/proyectos`, { params: { ejercicio, empresa_id: empresaId || 'all', page, limit } });

// Repartos manuales
export const getIvghRepartos = (proyectoId) =>
  axios.get(`${BASE}/ivgh/repartos`, { params: { proyecto_id: proyectoId } });

export const saveIvghRepartos = (data) =>
  axios.post(`${BASE}/ivgh/repartos`, data);

export const deleteIvghRepartos = (proyectoId) =>
  axios.delete(`${BASE}/ivgh/repartos/${proyectoId}`);

// Histórico y auditoría
export const getIvghHistorico = (ejercicio) =>
  axios.get(`${BASE}/ivgh/historico`, { params: { ejercicio } });

export const generarIvghSnapshot = (ejercicio, mes) =>
  axios.post(`${BASE}/ivgh/snapshot`, { ejercicio, mes });

export const cerrarIvghPeriodo = (ejercicio, mes) =>
  axios.post(`${BASE}/ivgh/cerrar`, { ejercicio, mes });

export const getIvghAuditLog = (limit = 50) =>
  axios.get(`${BASE}/ivgh/audit`, { params: { limit } });
